import type { Filter } from '@core/Entities/Search/SearchFilters/Filter.entity';
import { mapFiltersForDisplay } from '@core/Utils/SearchFilters/MapFiltersForDisplay';

export function generateFiltersForDisplay(filters: Filter[]) {
  const mappedFilters = mapFiltersForDisplay(filters);

  const areaFilter = mappedFilters.find(filter => filter.id === 'area');

  if (areaFilter?.value) {
    // If area is defined, remove postcode and max-distance filters
    const filteredFilters = mappedFilters.filter(
      filter => filter.id !== 'postcode' && filter.id !== 'max-distance',
    );
    return filteredFilters;
  }

  return mappedFilters;
}
